import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing, palette, breakpoints }) => ({
  header: {
    minHeight: '95px',
    height: '95px',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    boxShadow: `${spacing(0, 4, 4)} rgba(0, 0, 0, 0.25)`,
    padding: spacing(16, 24),
    // display: 'flex',
    display: 'flex',
    flexWrap: 'wrap',
    // gridTemplateColumns: `min-content min-content auto ${spacing(150)} ${spacing(120)} auto auto`,
    gap: spacing(15),
    rowGap: spacing(8),
    alignItems: 'center',
    zIndex: 1,
    [breakpoints.down('lg')]: {
      height: 'auto',
    },
    [breakpoints.down('md')]: {
      height: 'auto',
    },
  },
  tableContainer: {
    width: '100%',
  },

  buttons: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    gap: spacing(12),
    flexWrap: 'nowrap',
    zIndex: 2,
    [breakpoints.down('sm')]: {
      width: '100%',
      justifyContent: 'flex-end',
    },
  },
  chip: {
    width: 'fit-content',
    color: props => props.isCancelled && palette.gray[32],
    borderColor: props => props.isCancelled && palette.gray[32],
  },
  chipId: {
    width: 'fit-content',
    color: Theme.Colors.Grayscale.SixtyFour,
    backgroundColor: Theme.Colors.Grayscale.Twelve,
    borderRadius: spacing(24),
    height: spacing(24),
    textTransform: 'none',
    fontFamily: ['Roboto', 'sans-serif'],
    padding: '4px 8px',
    fontSize: '14px',
    lineHeight: '112.5%',
  },

  select: {
    marginBottom: spacing(16),
    minWidth: spacing(120),

    maxWidth: spacing(200),
  },
  button: {
    padding: spacing(6, 12),
    minWidth: spacing(100),
  },
  ownerDataButton: {
    minWidth: spacing(200),
  },
  buttonIcon: {
    display: 'flex',
    alignItems: 'center',
    marginRight: spacing(8),
  },
  cancelButton: {
    height: spacing(32),
    padding: spacing(0, 10),
  },
  text: {
    color: props => props.isCancelled && palette.gray[32],
  },
  category: {
    display: 'flex',
    gridTemplateColumns: 'auto auto',
    alignItems: 'center',
    gap: spacing(12),
  },
  scroll: {
    overflowY: 'visible',
    overflowX: 'hidden',
    margin: '0 8px 8px 0',

    '&::-webkit-scrollbar': {
      width: '6px',
      height: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#E3E3E3',
      borderRadius: '20px',
      margin: '30px',
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'gray',
      borderRadius: '20px',
      border: '3px solid gray',
    },
  },
  iconWhatsApp: {
    width: spacing(20),
    marginRight: spacing(6),
  },
  whatsButton: {
    background: palette.green.light,
    padding: spacing(6, 12.5),
    border: 'none',
    color: 'white',

    '&:hover': {
      background: palette.green.dark,
      border: 'none',
    },
  },
  menuDiv: {
    position: 'relative',
  },
  dialogContent: {
    maxHeight: 'unset',
    overflowY: 'visible',
    padding: spacing(12),
    minWidth: spacing(120),
  },
  modalColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  reportCheckbox: {
    width: 'auto',
    height: 'auto',
    marginRight: 0,
    padding: 0,
    marginLeft: spacing(2),
    '& .MuiFormControlLabel-label': {
      whiteSpace: 'normal',
    },
  },
}))
